import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {SelectorFieldOption} from './selector-field-option';

@Component({
  selector: 'custom-selector-field',
  templateUrl: './selector-field.component.html',
  styleUrls: ['./selector-field.component.scss']
})
export class SelectorFieldComponent implements OnInit {

  @Input() formGroup!: UntypedFormGroup;
  @Input() controlName: string = ""
  @Input() optionList: SelectorFieldOption[] = [];
  @Input() label?: string;
  @Input() shouldDisplayErrorMessage: boolean = true;

  // HTML helpers
  objectFn = Object;
  control!: UntypedFormControl;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.control = this.formGroup.controls[this.controlName] as UntypedFormControl;
  }

  getDefaultValidatorErrorMessage(validatorKey: string): string {
    if (validatorKey == 'required') {
      return this.translate.instant('form.required_field');
    } else {
      return this.translate.instant('form.error');

    }
  }
}
